'use client'

import { PropsWithChildren, useMemo, useTransition } from 'react'

import { HomepageTabModel } from '@marketplace-web/home/home-page-data'

import HomeContext from './HomeContext'

type Props = {
  homepageSessionId: string
  tabs: Array<HomepageTabModel>
}

const HomeProvider = ({ children, homepageSessionId, tabs }: PropsWithChildren<Props>) => {
  const [isLoading, startTransition] = useTransition()
  const value = useMemo(
    () => ({
      homepageSessionId,
      startTransition,
      isLoading,
      tabs,
    }),
    [homepageSessionId, tabs, startTransition, isLoading],
  )

  return <HomeContext.Provider value={value}>{children}</HomeContext.Provider>
}

export default HomeProvider
